<div class="row">
    <div class="col-md-12">
        <ax-panel title="Lotações/Atribuições já Desempenhadas pelo Paciente">
            <div class="row">
                <div class="col-md-12">
                    <ejs-grid #gridAtivas
                    [dataSource]="registros"

                    [enableVirtualization]='true'  height='450' 
                    [filterSettings]='filterSettings'
                    [searchSettings]='searchSettings'
                    [allowFiltering]='true' 
                    [allowSorting]='true' 
                    [allowResizing]='true' 

                    [showColumnChooser]='true'
                    [showColumnMenu]='true'
                    [pageSettings]='{ pageSize: 100 }'
                    [allowExcelExport]='true'
                    [allowPdfExport]='true'
                    [allowPdfExport]='true'
                    >
                    <e-columns>
                        <e-column field='id' [headerText]="'Id'" [visible]="false" [isPrimaryKey]="true"></e-column>
                        <e-column field='empresaRazaoSocial' [headerText]="'Empresa'"></e-column>
                        <e-column field='estabelecimentoNomeFantasia' [headerText]="'Estabelecimento'"></e-column>
                        <e-column field='cargoNome' [headerText]="'Cargo'"></e-column>
                        <e-column field='cargoParticularidade' [headerText]="'Part.'"></e-column>
                        <e-column field='cargoCbo' [headerText]="'CBO'"></e-column>
                        <e-column field='dataInicial' [headerText]="'Dt. Inicial'" [type]="'date'" [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='tipoDataInicialTexto' [headerText]="'Tipo Dt. Inicial'"></e-column>   
                        <e-column field='dataFinal' [headerText]="'Dt. Final'" [type]="'date'" [format]="{type: 'date', format: 'dd/MM/yyyy'}"></e-column>
                        <e-column field='tipoDataFinalTexto' [headerText]="'Tipo Dt. Final'"></e-column>   
                    </e-columns>

                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="id" type="count">
                                    <ng-template #footerTemplate let-data><b>Total: {{data.count}}</b></ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>

                </ejs-grid>
                </div>
            </div>
        </ax-panel>
    </div>
</div>